@if (store.vehicleInUse()) {
	<div
		class="position-fixed d-flex z-1 bg-white flex-row gap-2 py-2 px-3 justify-content-center align-items-center opacity-75 shadow-lg text-small"
	>
		<span>
			Wybrany pojazd: <span class="fw-bold"> {{ store.vehicleInUse().name }}</span>
		</span>
		<span>
			Wolne miejsca: <span class="fw-bold">{{ store.vehicleInUseFreeSeats() }}</span>
		</span>
		<button class="btn btn-primary text-small" (click)="toggleSidenav()">Zmień</button>
	</div>
}
